<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show">
                        <v-toolbar dark color="blue">
                            <v-toolbar-title>PLANILLA DE CAPACITACIONES QUE PASAN AL PLAN (EI 088)</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div>
                                <v-btn icon @click="show = false">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </div>
                        </v-toolbar>
                        <v-card-text color="blue lighten-5">
                            <v-row dense>
                                <v-col cols="6" sm="6" md="4">
                                    <h6> Nombre: {{ legajo }} - {{ nombre }} </h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="4">
                                    <h6> Responsable: {{ resp }} </h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <h6> Fecha: {{ fecha }} </h6>
                                </v-col>
                                <v-col cols="6" sm="6" md="2">
                                    <h6> Año: {{ periodo }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Gerencia: {{ gerencia }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="4">
                                    <h6> Sector: {{ sector }} </h6>
                                </v-col>
                                <v-col cols="12" sm="4" md="5">
                                    <h6> Puesto: {{ puesto }} </h6>
                                </v-col>

                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="blue lighten-5">
                        <v-data-table :headers="headers" :items="plan" locale="es-ar" class="elevation-1"
                            :items-per-page="100" hide-default-footer>
                            <template v-slot:item.plan="{ item }">
                                <div class="d-flex justify-center">
                                    <v-checkbox dense v-model="item.plan" color="red" value="ON"
                                        hide-details></v-checkbox>
                                </div>
                            </template>
                            <template v-slot:item.prioridad="{ item }">
                                <div class="d-flex justify-center">
                                    <v-select dense class="font-class-name" v-model="item.prioridad"
                                        :items="opcionprior" item-text="nombre" item-value="value"></v-select>
                                </div>
                            </template>
                            <template v-slot:item.obj="{ item }">
                                <div class="d-flex justify-center">
                                    <v-text-field dense class="font-class-name" v-model="item.obj"></v-text-field>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card>
                    <v-card color="blue" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style lang="scss">
.v-input--radio-group__input {
    label {
        margin: 0 !important;
    }
}
</style>

<style scoped>
::v-deep .right-input input {
    text-align: right !important;
}

.v-input input {
    text-align: right !important;
}

.v-text-field__slot input {
    text-align: right;
}

h6 {
    color: black;
}

.font-class-name {
    font-size: 14px;
}

.educacion {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
}

.educacion__niveles {
    border: solid 1px;
    list-style: none;
}
</style>
<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        lazy: false,
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        fecha: moment().format("DD/MM/YYYY"),
        //nombre: "",
        resp: "",
        gerencia: "",
        listadopolivalencia: [],
        opcioncapac: [
            { nombre: "NO", value: "NO" },
            { nombre: "SI", value: "SI" },
        ],
        opcionprior: [
            { nombre: "-", value: "-" },
            { nombre: "A", value: "A" },
            { nombre: "B", value: "B" },
            { nombre: "C", value: "C" },
        ],

        sector: "",
        puesto: "",

        headers: [
            { text: "Item", value: "item", width: "5%", sortable: false },
            { text: "Polivalencia", value: "poliv", width: "30%", sortable: false },
            { text: "Pasa al Plan?", value: "plan", sortable: false },
            { text: "Prioridad", value: "prioridad", sortable: false },
            { text: "Cod.Curso", value: "tema", sortable: false },
            { text: "Nombre del Curso asociado", width: "25%", value: "descr", sortable: false },
            { text: "Objetivo", value: "obj", width: "20%", sortable: false },
        ],

        plan: [],
        estados: [
            { nombre: 'Pendiente', valor: 'P' },
            { nombre: 'Cerrado', valor: 'C' },
        ],
        plancapacit: [],
        deshabilitar: false,
    }),

    props: ["visible", "legajo", "periodo", "nombre"],
    computed: {

        show: {
            get() {
                if (this.legajo != "" && this.periodo != "" && this.legajo != null && this.periodo != null && this.visible == true) {
                    this.deshabilitar = false;
                    this.cargarDatos();
                    this.cargarPlan();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargarDatos() {
            let self = this;
            self.policompetencias = []
            self.polivalencias = []
            axios
                .get("/RRHH/CargarPlanilla", {
                    params: {
                        legajo: self.legajo,
                        periodo: self.periodo,
                    },
                })
                .then((response) => {
                    //self.nombre = response.data.nombre;
                    self.fecha = response.data.fecha;
                    if (response.data.gerencia == "D") {
                        self.gerencia = "Dirección General";
                    }
                    if (response.data.gerencia == "A") {
                        self.gerencia = "Administración y Finanzas";
                    }
                    if (response.data.gerencia == "C") {
                        self.gerencia = "Comercialización";
                    }
                    if (response.data.gerencia == "F") {
                        self.gerencia = "Fabricación";
                    }
                    if (response.data.gerencia == "O") {
                        self.gerencia = "Obras y Servicios";
                    }
                    if (response.data.gerencia == "S") {
                        self.gerencia = "SGI";
                    }
                    if (response.data.gerencia == "M") {
                        self.gerencia = "SSGG y Mantenimiento";
                    }
                    if (response.data.gerencia == "B") {
                        self.gerencia = "Sucursal Bs As";
                    }
                    if (response.data.gerencia == "T") {
                        self.gerencia = "Técnina y Desarrollo";
                    }
                    self.sector = response.data.sector;
                    self.puesto = response.data.puesto;
                    self.resp = response.data.resp;

                })
                .catch((error) => {
                    self.gerencia = "";
                    self.sector = "";
                    self.puesto = "";
                    self.resp = "";
                    self.plan = [];
                    self.plancapacit = [];
                    console.log(error);
                });
        },

        cargarPlan() {

            const periodo = this.periodo;
            const legajo = this.legajo;
            let self = this;

            axios
                .get("/RRHH/CargarPlan?", {
                    params: {
                        periodo: periodo,
                        legajo: legajo,
                    },
                })
                .then((response) => {
                    self.plan = response.data;
                    console.log("plan", self.plan)
                })
                .catch((error) => {
                    self.plan = [];
                    console.log(error);
                });
        },

        vaciarListado() {
            this.poliv = [];
            this.resp = "";
            this.gerencia = "";
            this.puesto = "";
            this.sector = "";
            this.plan = [];
            this.plancapacit = [];

        },

        guardar() {
            this.$swal({
                title: "Guardar Plan de Capacitación",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.deshabilitar = true;
                    var pv = 0;
                    var pc = 0;
                    this.plan.forEach((element) => {
                        if (element.plan == "ON" && element.prioridad != "-") {
                            pv = pv + 1;
                            this.plancapacit.push({
                                item: pv,
                                legajo: this.legajo,
                                periodo: this.periodo,
                                tema: element.tema,
                                resp: this.resp,
                                prioridad: element.prioridad,
                                obj: element.obj,
                                codpoliv: element.codpoliv,
                            });
                        }
                    })

                    let self = this;
                    axios
                        .post("/RRHH/GuardarPlan", this.plancapacit)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.vaciarListado();
                            self.showAlert({
                                icon: "success",
                                title: "Plan guardado con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },

    },
};
</script>
